import { User } from './model';
import * as Actions from './actions';

const initialState: User = {
  dateFormat: '',
  dateTimeFormat: '',
  timeFormat: '',
  timeFormatHourAndMinute: '',
  errors: [],
  fullName: null,
  timezone: null,
  userId: null,
  username: null,
  updateCurrentUserLoaded: false,
  updateCurrentUserLoading: false,
  isUserLoaded: false,
  isUserLoading: false,
  isTokenRefreshed: false,
  isFeedTokenLoading: false,
  isFeedTokenLoaded: false,
  decimalSeparator: '.',
  thousandsSeparator: ','
};

export function userReducer(state: User = initialState, action: Actions.UserActions): User {
  switch (action.type) {
    case Actions.UPDATE_CURRENT_USER:
      return {
        ...state,
        updateCurrentUserLoading: true,
      };
    case Actions.UPDATE_CURRENT_USER_LOADED:
      return {
        ...state,
        updateCurrentUserLoaded: true,
        updateCurrentUserLoading: false,
      };
    case Actions.CLEAR_USER_LOAD_STATUS:
      return {
        ...state,
        updateCurrentUserLoaded: false,
        updateCurrentUserLoading: false,
      };
    case Actions.SET_USER_INFO:
      return {
        ...state,
        ...{
          username: action.username,
          userId: action.userId,
          userLevelId: action.userLevelId,
          fullName: action.fullName,
        },
      };

    case Actions.SET_USER_TIMEZONE:
      return {
        ...state,
        ...{ timezone: action.timezone },
      };

    case Actions.SET_USER_DATE_FORMAT:
      return {
        ...state,
        ...{
          dateFormat: action.dateFormat,
          dateTimeFormat: `${action.dateFormat} LT`,
          timeFormat: 'LTS',
          timeFormatHourAndMinute: 'LT',
        },
      };

    case Actions.CURRENT_USER_LOADING:
      return { ...state, isUserLoading: true };
    case Actions.CURRENT_USER_LOADED:
      return { ...state, isUserLoading: false, isUserLoaded: true };

    case Actions.FETCH_ERROR:
      return { ...state, errors: action.payload };

    case Actions.SET_ACCESS_TOKEN_LOADED:
      return { ...state, isTokenRefreshed: true };

    default:
      return state;
  }
}
